module.exports = __webpack_public_path__ + "static/media/web-4.cc1e02ac.jpg";